// src/app/pages/expediente/perfil-paciente/notas-internas-modal/notas-internas-modal.component.ts

import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IPatient } from '@commons/interfaces';

// ✅ INTERFACES
export interface NotaInterna {
  id: string; // <-- CORREGIDO: string en lugar de number
  titulo: string;
  contenido: string;
  fecha: string;
  hora: string;
  usuario: string;
  created_at?: string;
  updated_at?: string;
}

@Component({
  selector: 'app-notas-internas-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './notas-internas-modal.component.html',
  styleUrls: ['./notas-internas-modal.component.scss'],
})
export class NotasInternasModalComponent {
  @Input() patient: IPatient | null = null; // <-- CORREGIDO: acepta null
  @Input() notas: NotaInterna[] = [];

  @Output() close = new EventEmitter<void>();
  @Output() guardarNota = new EventEmitter<{ titulo: string; contenido: string }>();

  nuevaNota = {
    titulo: '',
    contenido: '',
  };

  /**
   * Cierra el modal
   */
  onClose() {
    this.close.emit();
  }

  /**
   * Guarda una nueva nota
   */
  onGuardar() {
    if (this.nuevaNota.titulo.trim() && this.nuevaNota.contenido.trim()) {
      this.guardarNota.emit({
        titulo: this.nuevaNota.titulo.trim(),
        contenido: this.nuevaNota.contenido.trim(),
      });

      // Limpiar formulario
      this.nuevaNota = {
        titulo: '',
        contenido: '',
      };
    }
  }

  /**
   * Cancela la edición y limpia el formulario
   */
  onCancelar() {
    this.nuevaNota = {
      titulo: '',
      contenido: '',
    };
  }

  /**
   * Calcula la edad del paciente
   */
  getEdad(): string {
    const birthDate = this.patient?.birth_date;

    if (!birthDate) {
      return '-';
    }

    const fechaNacimiento = new Date(birthDate);
    const hoy = new Date();
    let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
    const mes = hoy.getMonth() - fechaNacimiento.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNacimiento.getDate())) {
      edad--;
    }

    return `${edad} años`;
  }

  /**
   * Obtiene las alergias del paciente
   */
  getAlergias(): string {
    if (!this.patient?.alergias || this.patient.alergias.length === 0) {
      return 'Sin alergias';
    }

    return this.patient.alergias.join(', ');
  }

  /**
   * Obtiene la última receta del paciente
   */
  getUltimaReceta(): string {
    if (!this.patient?.ultima_receta) {
      return 'Sin recetas registradas';
    }

    return this.patient.ultima_receta;
  }
}
